import { retryLoader } from "./retryLoader"

export const polyfill = (): Promise<any> => {
  if (window.fetch as any) {
    return Promise.resolve()
  }
  return retryLoader(() => import(/* webpackChunkName: "polyfills" */ "Environment/polyfillLibs"))
}
